import React, { useEffect } from 'react'
import { useQueryParams } from '../lib/hooks/useQueryParams'
import { useGetUser } from '../api/auth/useGetUser'

const OAuthSuccess = (): JSX.Element => {
  const query = useQueryParams()
  const {} = useGetUser()
  const token = query.get('token')
  useEffect(() => {
    window.close()
  }, [])

  return <div>Success!</div>
}

export default OAuthSuccess
